import '/builds/gitlab/gitlab-ee/app/assets/javascripts/pages/projects/show/index.js?vue3';
import initTierBadgeTrigger from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/groups/init_tier_badge_trigger.js?vue3';
import initVueAlerts from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_alerts.js?vue3';
import { initComplianceInfo } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/pages/projects/show/init_compliance_info.js?vue3';
import { initDuoOtelInfo } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/pages/projects/show/init_duo_otel_info.js?vue3';

initVueAlerts();
initTierBadgeTrigger();
initComplianceInfo();
initDuoOtelInfo();
